module.exports = __webpack_public_path__ + "img/hero-bg.8414d973.jpg";